// extracted by mini-css-extract-plugin
module.exports = {"childrenContainer":"style_childrenContainer__d3pAq"};